import { render, staticRenderFns } from "./RForm.vue?vue&type=template&id=578410d8"
import script from "./RForm.vue?vue&type=script&lang=ts"
export * from "./RForm.vue?vue&type=script&lang=ts"
import style0 from "./RForm.vue?vue&type=style&index=0&id=578410d8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports